import { createApp } from 'vue';
const docsParent = document.getElementById('u-documents');
import MainComponent from "./components/MainComponent.vue";

if (docsParent) {
    createApp({
        components: {
            MainComponent
        },
        data() {
            return {};
        },
        mounted() {}
    }).mount(docsParent);
}